import { ApiClient, ApiRestrictedClient } from '../../api/api-types/client.api';
import { Client, RestrictedClient } from '../../api/app-types/client.app';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiClient = (obj: any): obj is ApiClient => {
	return obj && typeof obj === 'object' && 'guid' in obj;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiRestrictedClient = (obj: any): obj is ApiRestrictedClient => {
	return (
		!!obj &&
		typeof obj === 'object' &&
		typeof obj.id === 'number' &&
		typeof obj.name === 'string' &&
		(obj.firstName === undefined || typeof obj.firstName === 'string') &&
		!('guid' in obj)
	);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isClient = (obj: any): obj is Client => {
	return obj && typeof obj === 'object' && 'address' in obj;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRestrictedClient = (obj: any): obj is RestrictedClient => {
	return (
		!!obj &&
		typeof obj === 'object' &&
		typeof obj.id === 'number' &&
		typeof obj.name === 'string' &&
		(obj.firstName === undefined || typeof obj.firstName === 'string') &&
		!('address' in obj)
	);
};
